<template>
  <div>
    <div class="mongolia" v-if="isDown == true" @click="mongolia()">
      <img src="@/assets/image/dakai.png" alt="" />
      <div>Click on the upper right corner“...”<br />Choose to open in the browser<br />Download App</div>
    </div>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：下载弹框
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2021-06-28 10:26
 */
export default {
  data() {
    return {
      // isDown: false,
    };
  },
  props: {
    isDown: {
      type: Boolean,
      required: false,
    },
  },
  mounted() { },
  methods: {
    /**
     * Created by www.xingnuocn.com
     * @title：关闭蒙层
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2021-06-25 16:10
     */
    mongolia(val) {
      this.$emit("mongolia", val);
    },
  },
};
</script>
<style lang='scss' scoped>
.mongolia {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;

  >div {
    color: #ffffff;
    font-size: 26px;
    text-align: left;
    padding: 0 0 0 60px;
    margin-top: -40px;
  }

  >img {
    width: 300px;
    height: 140px;
    margin-left: 320px;
    margin-top: 40px;
  }
}
</style>